<template>
  <Page title="Wylogowanie" style="display: none;"></Page>
</template>
<script>
// import ViewMixin from "@/mixins/View";
// import UserApi from "@/api/User";

export default {
  name: "LogoutView",
  // mixins: [ViewMixin],
  mounted() {
    this.$store.dispatch("User/logout").then(() => {
      // this.$router.push("login");
      // window.location.reload();
      window.location = window.location.href;
    });
  }
};
</script>

<style></style>
